export const TIMEOUT_HTTP_STATUSES = [408, 504];

export const TIMEOUT_ERROR_MESSAGE = 'Request timed out. For best results, adjust the filters to narrow your search.';

function parseString(x: any): string | null {
    if (typeof x === 'string') return x;

    if (Array.isArray(x) && typeof x[0] === 'string') return x.join('. ');

    return null;
}

function parseAndTestString(x: any) {
    const es = parseString(x);
    return es && es.length < 2000 && ['<!DOCTYPE', '<!doctype', '<html'].every(x => !es.startsWith(x) && !es.startsWith(`\n${x}`)) ? es : null;
}

export function extractErrorMessage(
    error: any,
    taskDescription?: string,
    defaultMessage?: string,
    lookForMessage = false,
    additionalLookUpKeys: string[] = [],
    lookUpAllKeys = false
): string {
    let es = error?.error ?
        extractErrorMessage(error.error, taskDescription, defaultMessage, true, additionalLookUpKeys, lookUpAllKeys) :
        parseAndTestString(error);
    if (es) return es;

    const lookUpProps = ['detail', 'details', ...additionalLookUpKeys, 'non_field_errors'];
    if (lookForMessage) lookUpProps.push('message');
    if (lookUpAllKeys && typeof error === 'object') lookUpProps.push(...Object.keys(error));

    for (const key of lookUpProps) {
        es = parseAndTestString(error[key]);
        if (es) return es;
    }

    if (TIMEOUT_HTTP_STATUSES.includes(error?.status)) return TIMEOUT_ERROR_MESSAGE;

    if (defaultMessage) return defaultMessage;

    return taskDescription ? `An error occurred while trying to ${taskDescription}` : 'There was an error';
}

export interface FieldError {
    key: string;
    message: string;
}

const MESSAGE_KEYS = ['detail', 'details', 'non_field_errors', 'message'];

export function extractFieldErrors(error: any, skipKeys: string[] = MESSAGE_KEYS): FieldError[] {
    const body = error?.error !== undefined ? error.error : error;
    if (!body || typeof body !== 'object' || Array.isArray(body)) return [];

    return Object.entries(body)
        .filter(([key]) => !skipKeys.includes(key))
        .flatMap(([key, value]) => fieldErrorsOf(key, value));
}

function fieldErrorsOf(key: string, value: any): FieldError[] {
    if (Array.isArray(value)) return value.flatMap(one => fieldErrorsOf(key, one));
    if (value && typeof value === 'object') {
        return Object.entries(value).flatMap(([inner, one]) => fieldErrorsOf(`${key}.${inner}`, one));
    }
    const message = parseAndTestString(value);
    return message ? [{key, message}] : [];
}
